import { retrieveWorkQSlugFromId } from './misc'

export function pickWorkQueueId(item) {
    if (!item || typeof item !== 'object') {
        return null
    }
    const v =
        item.work_queue_id ??
        item.workQueueId ??
        item.work_queue?.id ??
        item.case?.work_queue_id
    if (v == null || v === '' || v === 0) {
        return null
    }
    return v
}

export function recentCasePersonNumber(item) {
    if (!item) {
        return null
    }
    return (
        item.person_number ??
        item.personNumber ??
        item.ng_number ??
        item.patient?.person_number ??
        null
    )
}

export function recentCaseQueueSlug(item) {
    const id = pickWorkQueueId(item)
    const fromSettings = id != null ? retrieveWorkQSlugFromId(id) : null
    return item?.workQSlug || item?.workQ || fromSettings || null
}

/**
 * Path for a recent patient row. Uses work-queue route only when slug resolves;
 * otherwise defaults to /cases/:personNumber.
 */
export function recentCaseHref(personNumber, item) {
    if (!personNumber) {
        return '/cases'
    }
    const slug = item ? recentCaseQueueSlug(item) : null
    return slug
        ? `/work-queues/${slug}/${personNumber}`
        : `/cases/${personNumber}`
}
